import { tasksSlice } from "./tasksSlice";
import * as actions from "./tasksActions";
import * as selectors from "./tasksSelectors";

export { actions };
export { selectors };
export default tasksSlice.reducer;